import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";

import {
  StakingPortfolioRiskThunk,
  StakingRiskRiskAlertThunk,
  UpdateStakingRiskInvestmentAlertThunk,
} from "../../Thunks/StakingRiskThunk";
import {
  renderClassName,
  resolveRiskValue,
} from "../StakingRiskCard/utils/stakingRiskHelpers";
import { EmptyCircularProgressBar } from "../EmptyCircularProgressBar";
import { LastMounthDefiCard } from "../LastMounthDefiCard";
import { CurrentDefiCard } from "../CurrentDefiCard";
import { WeekDefiCard } from "../WeekDefiCard";

let interval;

export default function StakingRiskAside({ openModal }) {
  const dispatch = useDispatch();
  const [openProgress, setOpenProgress] = useState(false);
  const [alertvalue, setValue] = useState(0);
  const [tab, setTab] = useState(1);

  const stakingPortfolioRiskResult = useSelector((state) => {
    return state.StakingRiskReducer.stakingPortfolioRiskResult;
  });
  const updateStakingRiskSuccess = useSelector((state) => {
    return state.StakingRiskReducer.updateStakingRiskInvestmentAlertSuccess;
  });
  const stakingRiskinvestmentRiskAlertResult = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskInvestmentRiskAlertResult;
  });

  const investmentRisk = resolveRiskValue(
    stakingPortfolioRiskResult?.investmentRisk,
  );

  const riskColor =
    investmentRisk >= 65
      ? "green"
      : investmentRisk >= 31
        ? "yellow"
        : investmentRisk > 0
          ? "red"
          : "white";

  const cardConfig = renderClassName(investmentRisk, riskColor, 178);

  const handleChange = (value, e) => {
    setValue(value);
  };

  useEffect(() => {
    if (interval) {
      clearInterval(interval);
    }
    dispatch(StakingPortfolioRiskThunk());
    interval = setInterval(() => {
      dispatch(StakingPortfolioRiskThunk());
    }, 15000); //15 second

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (updateStakingRiskSuccess) {
      dispatch(StakingPortfolioRiskThunk());
    }
  }, [updateStakingRiskSuccess]);

  const alertOnChangeComplete = (event) => {
    dispatch(UpdateStakingRiskInvestmentAlertThunk(+alertvalue, 1));
  };

  useEffect(() => {
    if (stakingRiskinvestmentRiskAlertResult) {
      stakingRiskinvestmentRiskAlertResult.map((element) => {
        if (element && element.type && element.type === 1) {
          setValue(+element.alert);
        }
      });
    }
  }, [stakingRiskinvestmentRiskAlertResult]);

  useEffect(() => {
    dispatch(StakingRiskRiskAlertThunk());
  }, []);

  return (
    <aside className="aside">
      <a
        href="#"
        className="add__wallet__btn"
        onClick={() => {
          openModal(true);
        }}
      >
        <span className="add__wallet__btn__plus">
          <span className="add__wallet__btn__plus__bg">
            <span></span>
            <span></span>
          </span>
        </span>
        Add Investment
      </a>
      <h3 className="aside__wallet__title">Portfolio Risk</h3>
      <div className="aside__chart__wrapper cold">
        {stakingPortfolioRiskResult &&
        stakingPortfolioRiskResult?.investmentRiskTrustScore ? (
          <div className="card__risk__chart">
            <CircularProgressBar {...cardConfig?.props}>
              <div className="round__shdow"></div>
              <div className="card__risk__chart__min__wrapper_aside">
                <p
                  className="card__risk__chart__number"
                  style={{
                    color: cardConfig?.props?.fontColor,
                  }}
                >
                  {investmentRisk}
                </p>
                <p
                  className="card__risk__chart__number__of"
                  style={{
                    color: cardConfig?.props?.fontColor,
                  }}
                >
                  {" "}
                  of 100{" "}
                </p>
              </div>
            </CircularProgressBar>
          </div>
        ) : (
          <EmptyCircularProgressBar />
        )}

        <div
          className={
            "card__risk__alert" +
            " " +
            (openProgress ? "active" : "card__risk__alert")
          }
          onClick={() => {
            setOpenProgress(!openProgress);
          }}
        >
          <p className="card__risk__alert__title">Alert</p>
          <p
            className={
              "card__risk__alert__number" +
              " " +
              (alertvalue === 0
                ? "card__risk__alert__not_number"
                : "card__risk__alert__number")
            }
          >
            {alertvalue === null || 0 ? 0 : alertvalue}
          </p>
        </div>
        {openProgress ? (
          <div
            className={
              "card__risk__range__hr active current__card" +
              " " +
              (alertvalue === 0
                ? "horizontal_slid_nit_value"
                : "card__risk__range__hr active current__card")
            }
          >
            <Slider
              min={0}
              max={100}
              value={alertvalue === null || 0 ? 0 : alertvalue}
              orientation="horizontal"
              onChange={handleChange}
              tooltip={false}
              onChangeComplete={alertOnChangeComplete}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <ul className="aside__tabs">
        <li
          className="aside__tabs__list"
          onClick={() => {
            setTab(1);
          }}
        >
          <a
            href="#"
            className={
              "aside__tabs__link" +
              " " +
              (tab === 1 ? "active" : "aside__tabs__link")
            }
          >
            24 hours
          </a>
        </li>
        <li
          className="aside__tabs__list"
          onClick={() => {
            setTab(2);
          }}
        >
          <a
            href="#"
            className={
              "aside__tabs__link" +
              " " +
              (tab === 2 ? "active" : "aside__tabs__link")
            }
          >
            7 days
          </a>
        </li>
        <li
          className="aside__tabs__list"
          onClick={() => {
            setTab(3);
          }}
        >
          <a
            href="#"
            className={
              "aside__tabs__link" +
              " " +
              (tab === 3 ? "active" : "aside__tabs__link")
            }
            onClick={() => {}}
          >
            1 month
          </a>
        </li>
      </ul>
      {tab === 1 ? (
        <CurrentDefiCard
          title={"stakingRisk"}
          element={stakingPortfolioRiskResult}
        />
      ) : (
        ""
      )}
      {tab === 2 ? (
        <WeekDefiCard
          title={"stakingRisk"}
          element={stakingPortfolioRiskResult}
        />
      ) : (
        ""
      )}
      {tab === 3 ? (
        <LastMounthDefiCard
          title={"stakingRisk"}
          element={stakingPortfolioRiskResult}
        />
      ) : (
        ""
      )}
    </aside>
  );
}
